import { render, staticRenderFns } from "./ProofChangeReviewAlerts.vue?vue&type=template&id=58bdb245"
import script from "./ProofChangeReviewAlerts.vue?vue&type=script&lang=js"
export * from "./ProofChangeReviewAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports